import baseService from '../shared/baseService';

const keywordService = (clientId: number) =>
  baseService(`clients/${clientId}/keywords`);
const keywordServiceDownload = (clientId: number) =>
  baseService('clients').download(`/${clientId}/keywords/download`);

export default {
  keywordService,
  keywordServiceDownload,
};
